import React from 'react';

export default function LoadingScreen() {
  return (
    <div className="h-full flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <img 
          src="https://zapt-cdn.com/dc408fb4-e206-4be6-8677-dfc0f17d99f7/Zapt_Navy%2BLogo%2B(1).png" 
          alt="ZAPT" 
          className="w-16 h-16 mx-auto mb-4 animate-pulse"
        />
        <div className="loading-spinner w-6 h-6 mx-auto mb-4"></div>
        <p className="text-gray-600">Loading ZAPT...</p>
      </div>
    </div>
  );
}